import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { setFaroView } from 'services/faroUserContext'

const FaroRouteTracker: React.FC = () => {
    const { pathname } = useLocation()

    useEffect(() => {
        setFaroView(pathname)
    }, [pathname])

    return null
}

export default FaroRouteTracker
